import { AfterViewInit, Component, ViewChild } from '@angular/core';
import html2canvas from 'html2canvas';
import * as CryptoJS from 'crypto-js';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatTable } from '@angular/material/table';
import { MaterialModule } from 'src/app/material.module';
import { AppBreadcrumbComponent } from "../../../../layouts/full/shared/breadcrumb/breadcrumb.component";
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EvlService } from '../../services/evl.service';
import { SharedService } from 'src/app/shared/services/shared.service';


@Component({
  selector: 'app-qr-generator',
  imports: [
    FormsModule,
    CommonModule,
    MaterialModule, TranslateModule,
    AppBreadcrumbComponent
  ],
  templateUrl: './qr-generator.component.html',
  styleUrl: './qr-generator.component.scss'
})
export class QrGeneratorComponent implements AfterViewInit {
  @ViewChild(MatTable, { static: true }) table: MatTable<any> =
    Object.create(null);
  base64QrCode: any;
  langCode: any;
  isArabic: boolean;

  constructor(private urlService: EvlService,
    private sharedService: SharedService,
    private toast: ToastrService, public translate: TranslateService
  ) {
    let lang: any = localStorage.getItem('lang');
    let langObj: any;
    if (lang != undefined && lang != null) {
      langObj = JSON.parse(lang);
      this.langCode = langObj.code;
    }
    else {
      this.langCode = 'ar';
    }
    this.translate.use(this.langCode);

    this.isArabic = this.langCode === 'ar';
  }

  baseUrl = environment.frontUrl
  secretKey = 'Nj5mW';
  generatedurl: string = "";
  url: string = "";
  allTables: any[] = [];
  selectedTable: any;
  fetchedNames: any[] = [];
  selectedName: any;
  selectedTableId: number = 0;
  qrCodeImageUrl: any;
  qrCodeImageBlob: Blob | null = null;
  encryptedurl: string = ""
  loading: boolean = false


  ngAfterViewInit(): void {
    this.loadEvaluationSubjects();
  }

  loadEvaluationSubjects(): void {
    this.sharedService.getDropDownList('evaluation/subject', true).subscribe(
      (response: { data: { filter: (arg0: (item: any) => boolean) => 
        { (): any; new(): any; map: { (arg0: (item: any) => 
          { nameEn: any; nameAr: any; id: any; controllerName: any; typeField: any; typeId: any; isActive: any; }): any[]; new(): any; }; }; }; }) => {
        this.allTables = response.data
          .filter((item: any) => item.nameEn !== 'Employee' && item.isActive === true)
          .map((item: any) => ({
            nameEn: item.nameEn,
            nameAr: item.nameAr,
            id: item.id,
            controllerName: item.controllerName,
            typeField: item.typeField,
            typeId: item.typeId,
            isActive: item.isActive
          }));
      },
      (error: any) => {
        this.toast.error('Failed to load evaluation subjects', 'Error');
        console.error('Error loading evaluation subjects:', error);
      }
    );
  }

  onTableSelect(event: any): void {
    this.fetchedNames = [];
    this.selectedName = null;
    this.qrCodeImageUrl = null;
    this.qrCodeImageBlob = null;

    if (!this.selectedTable || !this.selectedTable.id) {
      return;
    }

    this.loading = true;
    this.urlService.getEvaluationSubjectObjectsBySubjectId(this.selectedTable.id).subscribe(
      (response: { isSuccess: any; data: any[]; message: any; }) => {
        this.loading = false;

        if (response.isSuccess) {
          if (response.data && response.data.length > 0) {
            this.fetchedNames = response.data.map((item: any) => ({
              id: item.id,
              nameEn: item.nameEn,
              nameAr: item.nameAr
            }));

          } else {
            this.fetchedNames = [];
            this.toast.info(
              response.message || 'No items available for this evaluation subject',
              'Information'
            );
          }
        } else {
          this.fetchedNames = [];
          this.toast.warning(
            response.message || 'Failed to load items',
            'Warning'
          );
        }
      },
      (error: any) => {
        this.loading = false;
        console.error('Error fetching evaluation subject objects:', error);
        this.fetchedNames = [];

        this.toast.error(
          'An error occurred while loading items. Please try again.',
          'Error'
        );
      }
    );
  }

  onNameSelect(event: any): void {
    if (this.selectedName) {
      this.generateQr();
    }
  }

  generateQr(): void {
    if (!this.selectedTable || !this.selectedName) {
      return;
    }

    this.loading = true;
    this.qrCodeImageUrl = null;
    this.qrCodeImageBlob = null;

    this.selectedTableId = this.selectedTable.id;
    this.generatedurl = `${this.baseUrl}/user-evaluation/evaluation/${this.selectedTableId}/${this.selectedName.id}`;
    this.encryptedurl = this.encryptAndReplaceUrl(this.generatedurl);

    this.urlService.generateQr(this.encryptedurl).subscribe(
      (response: Blob) => {
        if (!response || response.size === 0) {
          alert('Error: Empty QR code received.');
          this.loading = false;
          return;
        }

        setTimeout(() => {
          this.qrCodeImageBlob = response;
          this.qrCodeImageUrl = URL.createObjectURL(response);
          this.loading = false;
        }, 500);
      },
      (error: any) => {
        alert('Oops! Something went wrong. Please try again.');
        this.loading = false;
        console.error('QR Generation Error:', error);
      }
    );
  }

  encryptAndReplaceUrl(url: string): string {
    // Extract everything after '/evaluation/'
    const parts = url.split('/evaluation/')[1];
    if (!parts) {
      return url;
    }

    // Encrypt the original string without modifying it
    const encryptedData = CryptoJS.AES.encrypt(parts, this.secretKey).toString();

    // Now replace slashes in the encrypted string
    let safeEncryptedData = encryptedData.replace(/\//g, '_slash_');
    safeEncryptedData = safeEncryptedData.replace(/\+/g, '_plus_');
    safeEncryptedData = safeEncryptedData.replace(/\%/g, '_percentage_');


    // Encode the modified encrypted data to be URL-safe
    const encodedEncryptedData = encodeURIComponent(safeEncryptedData);

    // Construct the final URL
    const newUrl = `${this.baseUrl}user-evaluation/evaluation/${encodedEncryptedData}`;
    return newUrl;
  }


  ngOnDestroy(): void {
    if (this.qrCodeImageUrl) {
      URL.revokeObjectURL(this.qrCodeImageUrl);
    }
  }

  printQr() {
    const printWindow = window.open('', 'Stars neon Evaluation QR Code');

    if (printWindow) {
      // Using an arrow function to ensure 'this' refers to the component
      printWindow.document.write(`
        <html>
        <head>
          <title></title>
          <style>
           @page { margin: 0; }
            body { text-align: center; padding: 20px;  }
          
          </style>
        </head>
        <body id="capture-content">
       <nav style="display:flex; justify-content:center; margin-top:20px;">
            <img src="${location.origin}/assets/images/logos/logo-light.svg" alt="Logo" style="width: 270px;">
          </nav>
          <div style="margin-top: 70px !important;" >
          <h2 style="font-size:26px">امسح الرمز لمشاركة تقييمكم</h2>
            <h2 style="font-size:26px">Scan the QR Code To Share Your Feedback</h2>
           <p style="font-size:22px">${this.selectedName.nameAr}</p>
            <p style="font-size:22px">${this.selectedName.nameEn}</p>
            <img src="${this.qrCodeImageUrl}" alt="QR Code" style="width:500px ; height:500px"/>
            <p class="text-muted" style="font-size:22px">نود سماع رأيك! لا تتردد في مشاركة أفكارك معنا.</p>
            <p class="text-muted" style="font-size:22px">We’d love to hear your feedback! Feel free to share your thoughts with us.</p>
          </div>
          <script>
            window.onload = function() {
              window.print();
  
              // Capture and save the QR code after the page has loaded
              window.setTimeout(function() {
                // Passing 'this' as a parameter to access the Angular method
                window['captureAndSave']();
                setTimeout(() => { window.close(); }, 500);
              }, 1000);
            };
          </script>
        </body>
        </html>
      `);

      printWindow.document.close();

      // Attach a method to the printWindow to capture and save the image after printing
      (printWindow as any)['captureAndSave'] = () => {
        const contentToCapture = printWindow.document.getElementById("capture-content");

        if (contentToCapture) {
          html2canvas(contentToCapture).then(canvas => {
            // Convert the canvas to a base64 encoded PNG image
            const base64Image = canvas.toDataURL('image/png');

            if (base64Image) {
              // Send the captured base64 image string to save
              this.base64QrCode = base64Image;  // Store base64 string
              this.saveQrImage();  // Now call saveQrImage after the image is captured
            } else {
            }

          }).catch(error => {
          });
        } else {
        }
      };
    }
  }

  saveQrImage() {
    if (this.base64QrCode) {

      this.urlService.saveQrImage(this.base64QrCode).subscribe((response: any) => {
        this.toast.success("QR code saved !", '');
      }, (error: any) => {
      });
    } else {
    }
  }
}
